import React, { useContext, useEffect } from "react";
import { ConfigurationContext } from "contexts";
import { Typography, Button, Row, Col } from "antd";
import { useSteps, useLogger } from "hooks";
import { ExclamationCircleTwoTone } from "@ant-design/icons";

const { Paragraph, Title } = Typography;
const stepName = "start";

// /**
//  *  Is the OS supported.
//  *
//  *  @param {object} config
//  */

// const osSupported = (config) => {
//   return config.os.includes("win") || config.os.includes("mac") || config.os.includes("chrome");
// };

// /**
//  *  Is the browser supported.
//  *
//  *  @param {object} config
//  */

// const browserSupported = (config) => {
//   return !(config.browser.includes("explorer") || config.browserVersion.major < 11);
// };

/**
 *  The component.
 */

const StepStart = () => {
  let config = useContext(ConfigurationContext);
  let { setCompleted, nextStep } = useSteps();
  let logger = useLogger();

  const shouldRender = () => {
    // Run if the config isn't valid.
    if (!config.valid) {
      return true;
    }
    return false;
  };

  const finish = () => {
    setCompleted(stepName);
    nextStep();
  };

  useEffect(() => {
    // Check whether we should move on.
    if (!shouldRender()) {
      finish();
    }
  }, []);

  if (!shouldRender()) {
    return null;
  }

  // Currently, we only render if there was an error in the configuration as in the OS isn't supported.

  return (
    <>
      <Row className="mt-5" justify="center" align="top" gutter={[16, 0]}>
        <Col>
          <ExclamationCircleTwoTone
            className="mt-2"
            style={{ fontSize: "32px" }}
            twoToneColor="#ff1010"
          />
        </Col>
        <Col>
          <Title>Not Supported</Title>
        </Col>
      </Row>
      <Row>
        <Col style={{ fontSize: "1.2em" }}>
          <Paragraph>{`${config.os} isn't supported at this time.`}</Paragraph>
        </Col>
      </Row>
      <Row className="mt-5" justify="center" gutter={[16, 16]}>
        <Col>
          <Button
            size="large"
            type="primary"
            onClick={() => {
              window.history.back();
            }}
          >
            Go Back
          </Button>
        </Col>
      </Row>
      {/* <Title style={{ textAlign: "center" }}>Welcome to System Detection</Title>
      {!browserSupported(config) ? <Text>{`We're sorry but ${config.os} is not supported.`}</Text> : null};
      {!osSupported(config) ? <Text>{`We're sorry but ${config.os} is not supported.`}</Text> : null};
      <div style={{ textAlign: "center" }}>
        <Button
          type='primary'
          onClick={() => {
            finish();
          }}>
          Next
        </Button>
      </div> */}
    </>
  );
};

export default StepStart;
